module.exports = __webpack_public_path__ + "static/logo-redbull-ce3d6303ca806621b68079cb553735f5.svg";